import $ from 'jquery';
import Vue from 'vue';
import sendAjax from './sendAjax';


export function parseHiddenFields(el) {
  let fields = Object.create(null);
  for (let i in el.attributes) {
    if (el.attributes.hasOwnProperty(i)) {
      let matches = /^data-hidden-([a-z]+.*)/.exec(el.attributes[i].name);
      if (matches) {
        fields[matches[1]] = el.attributes[i].value;
      }
    }
  }

  return fields;
}

export default Vue.extend({
  data() {
    return {
      ns   : 'ajax-form',
      state: {},
      model: {},

      form: {
        hiddenFields: {},
        loading     : false,
        submitted   : false,
        status      : null,
        message     : '',
      },

      messages: {
        required: 'Поле не заполнено',
        accept  : 'Необходимо принять политику конфиденциальности и пользовательское соглашение',
        email   : 'Некорректный email',
      },

      defaultState: {},
    };
  },

  mounted() {
    if (this.inited && typeof this.inited === 'function') {
      this.inited();
    }

    this.defaultState = {...this.model};

    this.form.hiddenFields = parseHiddenFields(this.$el);

    setTimeout(() => {
      this.$el.classList.add('form_state_mounted');
    }, 500);
  },

  methods: {
    addData(fd) { return fd; },

    formSubmit(e) {

      if (this.state.$invalid) {
        console.warn('Form invalid!');
        return;
      }

      let method = $(e.target).attr('method') || 'POST';
      let action = $(e.target).attr('data-action') || $(e.target).attr('action');

      let formData = new FormData(e.target);
      formData     = this.addData(formData);

      this.form.loading = true;
      this.disableSubmit(e, true);

      sendAjax(action, {
        method: method,
        body  : formData,
      })
      .then((json) => {
        console.log('RESPONSE', json);
        this.form.message = json['message'] || '';
        this.form.loading = false;
        this.showStatus();
        this.disableSubmit(e, false);
      })
      .catch((error) => {
        console.error(error);
        this.form.message = error.toString();
        this.form.loading = false;
        this.showStatus(false);
        this.disableSubmit(e, false);
      });
    },

    resetForm() {
      this.model = {...this.defaultState};
      this.state._reset();
    },

    showStatus(status = true) {
      this.form.submitted = true;
      this.form.status    = status;
    },

    hideStatus() {
      this.form.submitted = false;
      this.form.status    = null;
      this.resetForm();
    },

    disableSubmit(form, lock = true) {
      $('[type="submit"]', form.target).attr('disabled', lock);
    },

    fid(name) {
      return this.ns + this._uid + '-' + name;
    },
  },
});



// WEBPACK FOOTER //
// ./source/js/components/AjaxForm.js